import { i18n } from '@shared';

export function getBadgeColorByStatus(
	status: SendingStatus | RecipientSendingStatus,
): string {
	switch (status) {
		case 'draft':
			return 'yellow';
		case 'scheduled':
			return 'yellow';
		case 'waitingToBeSent':
			return 'yellow';
		case 'sending':
			return 'yellow';
		case 'ongoing':
			return 'yellow';
		case 'completed':
			return 'green';
		case 'sent':
			return 'green';
		case 'error':
			return 'red';
		case 'notSent':
			return 'red';
		default:
			return 'yellow';
	}
}
export function getSendingStatusTranslation(
	status: SendingStatus | RecipientSendingStatus,
): string {
	switch (status) {
		case 'draft':
			return i18n.t('general.status_draft');
		case 'scheduled':
			return i18n.t('general.status_scheduled');
		case 'waitingToBeSent':
			return i18n.t('general.status_waiting_to_be_sent');
		case 'sending':
			return i18n.t('general.sending');
		case 'ongoing':
			return i18n.t('general.status_ongoing');
		case 'completed':
			return i18n.t('general.status_completed');
		case 'sent':
			return i18n.t('general.sent');
		case 'error':
			return i18n.t('general.status_error');
		case 'notSent':
			return i18n.t('general.not_sent');
		default:
			return i18n.t('general.status_unknown');
	}
}

// LIST UPDATED ON 28/07/2025
export function getMessageStatusInfo(code: number): {
	status: string;
	description: string;
} {
	const statusMap: {
		[key: number]: { status: string; description: string };
	} = {
		1: {
			status: 'Accepted',
			description:
				'Initial status indicating message is accepted for processing.',
		},
		2: {
			status: 'Scheduled',
			description:
				'Initial status indicating that a scheduled message is accepted for sending.',
		},
		1000: {
			status: 'Queued',
			description:
				'Message is currently queued in the SMSC and will be forwarded to the operator.',
		},
		1001: {
			status: 'Sent',
			description: 'Message sent to message gateway.',
		},
		2000: {
			status: 'Delivered',
			description: 'Message has been delivered to the final recipient.',
		},
		3000: {
			status: 'Rejected',
			description:
				'User, account or password could not be validated. Message was not sent.',
		},
		3001: {
			status: 'Rejected',
			description:
				'An error occurred in the provisioning of your account.',
		},
		3002: {
			status: 'Rejected',
			description: 'Invalid sender. Possibly too long or unauthorized.',
		},
		3003: {
			status: 'Rejected',
			description:
				'Sender type not supported (e.g. short code, alpha sender, etc.).',
		},
		3004: {
			status: 'Rejected',
			description:
				'Invalid recipient number (e.g. landline or incorrectly formatted).',
		},
		3005: {
			status: 'Rejected',
			description: 'Destination type not supported.',
		},
		3006: {
			status: 'Rejected',
			description: 'Encoding not supported by country or operator.',
		},
		3007: {
			status: 'Rejected',
			description: 'Invalid or unsupported message content.',
		},
		3008: {
			status: 'Rejected',
			description: 'Invalid user data header for concatenated messages.',
		},
		3009: {
			status: 'Rejected',
			description: 'Maximum message throttling exceeded.',
		},
		3010: {
			status: 'Rejected',
			description: 'One or more validations failed.',
		},
		3011: {
			status: 'Rejected',
			description: 'Quota exceeded for the messaging channel.',
		},
		3013: {
			status: 'Rejected',
			description: 'Message sent to a blocked country.',
		},
		4000: {
			status: 'Unable to send',
			description: 'Generic error. Contact Support.',
		},
		4001: {
			status: 'Unable to send',
			description:
				'Temporary routing error. May be a configuration issue.',
		},
		4002: {
			status: 'Unable to send',
			description: 'Permanent routing error. No route to number.',
		},
		4003: {
			status: 'Failed',
			description: 'Phone number is blocked by the SMSC or operator.',
		},
		4004: {
			status: 'Failed',
			description: 'Recipient is temporarily barred.',
		},
		4005: {
			status: 'Failed',
			description: 'Operator-side error. Message not delivered.',
		},
		4006: {
			status: 'Failed',
			description:
				'Operation blocked for this country, operator, or recipient.',
		},
		4007: {
			status: 'Failed',
			description: 'Message sent to operator but not delivered.',
		},
		4008: {
			status: 'Failed',
			description:
				'Message expired before delivery (e.g. phone off or out of coverage).',
		},
		4009: {
			status: 'Failed',
			description: 'Timeout occurred. Final status unknown.',
		},
		4010: {
			status: 'Failed',
			description: 'Operator does not support delivery reports.',
		},
		4011: { status: 'Failed', description: 'Message deleted by operator.' },
		5000: {
			status: 'Retried',
			description: 'Retrying to send message to gateway.',
		},
	};

	return (
		statusMap[code] || {
			status: 'Unknown',
			description: 'No description available for this code.',
		}
	);
}
